/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function TextZoom16(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'TextZoom16',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"opacity":".8","fillRule":"evenodd","clipRule":"evenodd","d":"M11.215 12.59a7 7 0 1 1 1.494-1.537l2.89 2.889-1.516 1.515zM12.5 7a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0","fill":"currentColor"}),createElement('path', {"d":"M5.358 9.73h-1.36l2.072-6h1.635l2.069 6h-1.36L6.911 5.102h-.047l-1.506 4.63zm-.085-2.358h3.212v.99H5.273z","fill":"currentColor"}))
}
